// import wallet from '../../../assets/icons/backOffice/Packages/wallet.svg';
import wallet from '../../../../assets/icons/backOffice/Packages/wallet.svg';

import { useTranslation } from 'react-i18next';
import {
  copyLink,
  formatUSD,
  showNetworkType,
  showTokenType,
  USDT
} from '../../../../helpers/helperFunctions';
import { H3, P3 } from '../../../../styles/FontStyles';
import { colors } from '../../../../styles/GlobalStyles';

import styled from 'styled-components';

import { useAppSelector } from '../../../../app/hooks';
import Spinner from '../../../../components/common/Spinner';
import { MyOrderListModel } from '../../../Marketplace/Maeketplace.types';

const SelectedUSDT = styled.div<{ isUpperCase?: boolean }>`
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;

  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.color
      ? props.theme.colors.neutral500
      : props.theme.colors.neutral900};
  border-radius: 8px;
  padding: 0 16px;
  background: ${(props) => props.theme.colors.neutral100};
  ${({ isUpperCase }) => isUpperCase && 'text-transform: uppercase;'};
`;

interface TransferProps {
  selectedPackage: any;
}

const WaitingForPaymentTranfer = ({ selectedPackage }: TransferProps) => {
  const { t } = useTranslation('packages');
  const { loading } = useAppSelector((state) => state.marketplace);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <P3 bold mb='8' mt='20' color={colors.neutral900}>
            {t('waiting.you_selected')}
          </P3>

          <P3 mb='8' mt='20' color={colors.neutral900}>
            {t('waiting.text1')}
          </P3>

          <P3 mb='8' mt='20' color={colors.neutral900}>
            {t('waiting.text2')}
          </P3>

          <P3 mb='8' mt='20' color={colors.neutral900}>
            {t('waiting.text3')}
          </P3>

          <P3 bold mb='8' mt='20' color={colors.neutral900}>
            {t('waiting.payment_amount')}
          </P3>

          <SelectedUSDT>{formatUSD(selectedPackage?.price)}</SelectedUSDT>

          <P3 bold mb='8' mt='20' color={colors.neutral900}>
            Selected {t('waiting.network')}
          </P3>

          <SelectedUSDT>{showNetworkType(selectedPackage)}</SelectedUSDT>

          <P3 bold mb='8' mt='20' color={colors.neutral900}>
            Selected Token
          </P3>

          <SelectedUSDT isUpperCase>
            {selectedPackage?.currencyType}
          </SelectedUSDT>

          <P3 bold mb='8' mt='20' color={colors.neutral900}>
            {t('waiting.wallet_address')}
          </P3>

          <SelectedUSDT
            onClick={() => {
              copyLink(selectedPackage?.paymentAddress, t('waiting.copied'));
            }}
            style={{ cursor: 'pointer' }}>
            <div className='truncated'>
              <div>{selectedPackage?.paymentAddress}</div>
            </div>

            <img
              src={wallet}
              alt='withdraw'
              style={{ width: 16, marginLeft: 10 }}
            />
          </SelectedUSDT>
        </div>
      )}
    </>
  );
};

export default WaitingForPaymentTranfer;
